import Cookies from "js-cookie";

import type { AnalyticParamsType } from "./types";

export const setCookie = (cookie: AnalyticParamsType, value: string) => {
  Cookies.set(cookie, value);
};

export const getCookie = (cookie: AnalyticParamsType) => {
  return Cookies.get(cookie);
};
